import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Modal, Popconfirm, Space, Table} from "antd";
import {CheckSquare, Edit2, Eye, Feather, Menu as MENU, Trash, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import $ from "jquery";
import API_LINK from "../components/links/Link";
import {RiCheckDoubleFill, RiEjectLine} from "react-icons/ri";
import {BiCheckDouble} from "react-icons/bi";
import {MdDone} from "react-icons/md";

export default function ActiveAppointments() {
    const history = useHistory();
    const [jobData, setJobData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        LoadAppointments();
    }, []);

    const LoadAppointments = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
             if (localStorage.getItem("Role") == "User")
                formdata.append("page", "LoadMyAppointments");
             else
            formdata.append("page", "LoadAppointments");
            formdata.append("id", localStorage.getItem("UserId"));
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Appointment.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setJobData(result.data);
                            setFilterData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const handleSearch = (value) => {
        if (value) {
            const filtered = filterData.filter((item) => item.Name.toLowerCase().includes(value.trim().toLowerCase()) || item.Email.toLowerCase().includes(value.trim().toLowerCase()) || item.AppointmentDate.toLowerCase().includes(value.trim().toLowerCase()));
            setJobData(filtered);
        } else {
            setJobData(filterData);
        }

    };

    function markAsDone(j, status) {
        let toaster;
        toaster = toast.loading("Processing...");
        try {
            const formdata = new FormData();
            formdata.append("page", "UpdateAppointmentStatus");
            formdata.append("id", j.id);
            formdata.append("status", status);
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            fetch(`${API_LINK}Appointment.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    if (result.status === 1) {
                        setTimeout(() => {
                            toast.update(toaster, {
                                type: "success",
                                render: "Appointment Status Updated!",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })
                            LoadAppointments();
                        }, 1000)
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                })
                .catch(error => console.log('error', error));
        } catch (e) {
            console.log(e);
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Active Appointments</h2>
                    <span>want to manage the active appointments?</span>
                    <div className="content-card">
                        <div className="table-search">
                            <input type="search" placeholder='Type to search...'
                                   onChange={(e) => handleSearch(e.target.value)}/>
                        </div>
                        <Table dataSource={jobData} pagination={{pageSize: 10}}
                               loading={isLoading}
                               rowHoverable={true}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }}/>
                            <Table.Column title="Name" dataIndex="Name"/>
                            <Table.Column title="Email Address" dataIndex="Email"/>
                            <Table.Column title="Phone No." dataIndex="PhoneNo"/>
                            <Table.Column title="Have Insurance?" render={(j) => {
                                if (j.Image)
                                    return (
                                        <a href={j.Image} download target={'_blank'}>
                                            <img src={j.Image} alt="Insurance Image"
                                                 style={{
                                                     width: '100px',
                                                     height: '100px',
                                                     borderRadius: '10px'
                                                 }}/>
                                        </a>
                                    )
                                else {
                                    return <p>No</p>
                                }
                            }}/>
                            <Table.Column title="Appointment Date" dataIndex="AppointmentDate"/>
                            <Table.Column title="Appointment Time" render={(j) => {
                                const time = JSON.parse(j.AppointmentTime);
                                return (<>
                                    <p>{time.day}</p>
                                    <p>{time.type}</p>
                                    <p>{time.hour}</p>
                                </>)
                            }}/>
                            <Table.Column title="Doctor Details" render={(j) => {
                                const doctor = JSON.parse(j.Doctor);
                                return (<>
                                    <img src={doctor.image} alt="Doctor Image"
                                         style={{width: 60, height: 60, borderRadius: 50}}/>
                                    <p>{doctor.name}</p>
                                    <a href={`mailto:${doctor.email}`} target={'_blank'}>{doctor.email}</a>
                                </>)
                            }}/>
                            <Table.Column title="Date" dataIndex="Date"/>
                            <Table.Column title="Status" dataIndex="Status"/>
                            {
                                localStorage.getItem("Role") !== "User" &&
                                <>
                                    <Table.Column title="Accept" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to mark this appointment as active?'}
                                                        onConfirm={() => {
                                                            markAsDone(j, "Active")
                                                        }}
                                            >
                                                <Button type='primary' icon={<MdDone size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                    <Table.Column title="Reject" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to reject this appointment?'}
                                                        onConfirm={() => {
                                                            markAsDone(j, "Rejected")
                                                        }}
                                            >
                                                <Button type='primary' danger icon={<RiEjectLine size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                    <Table.Column title="Mark&nbsp;As&nbsp;Done" render={(j) => {
                                        return (
                                            <Popconfirm title={'Are you sure?'}
                                                        description={'You want to mark this appointment as done?'}
                                                        onConfirm={() => {
                                                            markAsDone(j, "Done")
                                                        }}
                                            >
                                                <Button type='primary' icon={<BiCheckDouble size={15}/>}/>
                                            </Popconfirm>
                                        )
                                    }}/>
                                </>
                            }


                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
